import { NavigationItem } from '../../../data/types';
import s from './Navigation.scss';

export interface StartNowProps {
  link: NavigationItem;
  t(key: string): string;
}

export const StartNow = ({ link, t }: StartNowProps): string => {
  return `
    <li data-hook="userMenu" class="${s.menuItem} ${s.userMenu}">
      <a class="${s.startNow}" href="${link.href}">
        ${t(link.text)}
      </a>
    </li>
  `;
};
